import type { ReactElement } from 'react';

type Props = {
  description: string;
  onDescriptionChange: (v: string) => void;
  internalNotes: string;
  onInternalNotesChange: (v: string) => void;
};

export function DescriptionSection({
  description,
  onDescriptionChange,
  internalNotes,
  onInternalNotesChange,
}: Props): ReactElement {
  return (
    <section
      id="section-description"
      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
    >
      <h2 className="mb-4 text-lg font-semibold text-slate-950">Description</h2>
      <textarea
        className="min-h-[100px] w-full rounded-xl border border-slate-300 px-3 py-2"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
      />
      <label className="mt-4 block">
        <span className="text-sm font-medium text-slate-700">Internal notes</span>
        <textarea
          className="mt-1 min-h-[80px] w-full rounded-xl border border-slate-300 px-3 py-2"
          value={internalNotes}
          onChange={(e) => onInternalNotesChange(e.target.value)}
        />
      </label>
    </section>
  );
}
